import { AuthenticatedRoute } from 'components/AuthenticatedRoute/AuthenticatedRoute'
import { LaunchDarklyDependentContent } from 'components/LaunchDarklyDependentContent/LaunchDarklyDependentContent'
import { Error404 } from 'Error404'
import { FC } from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import { ClaimsSearchPage } from './pages/ClaimsSearchPage'
import { ClaimDetails } from './pages/ClaimDetails'
import { ClaimDeductibles } from './pages/ClaimDeductibles'
import { MSA } from './pages/MSA'
import { MSP } from './pages/MSP'

export const ClaimsSwitch: FC = () => {
  const match = useRouteMatch()
  const matchedPath = match.path

  const routes = {
    claimsResults: `${matchedPath}/`,
    claimDetails: `${matchedPath}/claim-details`,
    claimDeductibles: `${matchedPath}/claim-deductibles`,
    MSA: `${matchedPath}/msa`,
    MSP: `${matchedPath}/msp`
  }

  return (
    <Switch>
      <AuthenticatedRoute
        path={routes.claimsResults}
        exact
        redirectPath={routes.claimsResults}
      >
        <LaunchDarklyDependentContent
          flagName="claims"
          fallbackContent={<Error404 />}
        >
          <ClaimsSearchPage />
        </LaunchDarklyDependentContent>
      </AuthenticatedRoute>
      <AuthenticatedRoute
        path={routes.claimDetails}
        exact
        redirectPath={routes.claimsResults}
      >
        <LaunchDarklyDependentContent
          flagName="claims"
          fallbackContent={<Error404 />}
        >
          <ClaimDetails />
        </LaunchDarklyDependentContent>
      </AuthenticatedRoute>
      <AuthenticatedRoute
        path={routes.claimDeductibles}
        exact
        redirectPath={routes.claimDeductibles}
      >
        <LaunchDarklyDependentContent
          flagName="claimsDeductible"
          fallbackContent={<Error404 />}
        >
          <ClaimDeductibles />
        </LaunchDarklyDependentContent>
      </AuthenticatedRoute>
      <AuthenticatedRoute path={routes.MSA} redirectPath={routes.MSA}>
        <LaunchDarklyDependentContent
          flagName="useNewMsa"
          fallbackContent={<Error404 />}
        >
          <MSA />
        </LaunchDarklyDependentContent>
      </AuthenticatedRoute>
      <AuthenticatedRoute path={routes.MSP} redirectPath={routes.MSP}>
        <LaunchDarklyDependentContent
          flagName="useNewMsp"
          fallbackContent={<Error404 />}
        >
          <MSP />
        </LaunchDarklyDependentContent>
      </AuthenticatedRoute>
      <Route>
        <Error404 />
      </Route>
    </Switch>
  )
}
